/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — Sales POC analytics dashboard — RTK Query slice. Real data:
   revenue/shipments come from growthos_revenue_daily (rolled up from live MongoOrder
   data), deal metrics from real GrowthOsDeal documents.
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get, post } from '../common/constants'

const ANALYTICS = apiConstants.GROWTHOS_ADMIN_SALES_POC_ANALYTICS // 'growthos-admin/analytics/sales-pocs'
const ROLLUP = apiConstants.GROWTHOS_ADMIN_REVENUE_ROLLUP // 'growthos-admin/revenue-rollup'

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

export const growthosPocAnalyticsApiSlice = createApi({
  reducerPath: 'growthosPocAnalyticsApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['PocAnalytics'],
  endpoints: (b) => ({
    getPocDashboard: b.query({
      queryFn: ({ period, from, to }) => run(get(ANALYTICS, { period, from, to })),
      providesTags: ['PocAnalytics'],
    }),
    getPocIndividual: b.query({
      queryFn: ({ personId, period, from, to }) => run(get(`${ANALYTICS}/${personId}`, { period, from, to })),
      providesTags: ['PocAnalytics'],
    }),
    triggerRevenueSync: b.mutation({
      queryFn: () => run(post(`${ROLLUP}/sync`)),
      invalidatesTags: ['PocAnalytics'],
    }),
    triggerRevenueBackfill: b.mutation({
      queryFn: (months) => run(post(`${ROLLUP}/backfill?months=${months || 24}`)),
      invalidatesTags: ['PocAnalytics'],
    }),
  }),
})

export const {
  useGetPocDashboardQuery,
  useGetPocIndividualQuery,
  useTriggerRevenueSyncMutation,
  useTriggerRevenueBackfillMutation,
} = growthosPocAnalyticsApiSlice
